import * as React from "react";
import i18next from "i18next";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { useMapContext } from "../../Contexts/MapContext";
import { DrawType } from "../enums";
import { ColorButton } from "./ColorButton";
import { WidgetToolbar } from "../Widget/WidgetToolbar";
import { WidgetToolbarButton } from "../Widget/WidgetToolbarButton";
import "./DrawingToolbar.scss";

export const DrawingToolbar = (): JSX.Element => {
    const { drawType } = useMapContext();
    const { color, colorsVisible, setColorsVisible, onDrawStart } = useDrawingContext();

    const onColorClick = () => setColorsVisible(!colorsVisible);

    return (
        <WidgetToolbar className={"drawing-toolbar"}>
            <WidgetToolbarButton
                iconClass="icon-geolite-pin"
                buttonClass={drawType === DrawType.Point ? "active" : ""}
                title={i18next.t("sketch.choosePoint")}
                onClick={() => onDrawStart(DrawType.Point)}
            />
            <WidgetToolbarButton
                iconClass="icon-geolite-distance"
                buttonClass={drawType === DrawType.Polyline ? "active" : ""}
                title={i18next.t("sketch.chooseLine")}
                onClick={() => onDrawStart(DrawType.Polyline)}
            />
            <WidgetToolbarButton
                iconClass="icon-geolite-area"
                buttonClass={drawType === DrawType.Polygon ? "active" : ""}
                title={i18next.t("sketch.chooseArea")}
                onClick={() => onDrawStart(DrawType.Polygon)}
            />
            <WidgetToolbarButton
                iconClass="icon-geolite-text"
                buttonClass={drawType === DrawType.PointText ? "active" : ""}
                title={i18next.t("sketch.chooseText")}
                onClick={() => onDrawStart(DrawType.PointText)}
            />
            <ColorButton onClick={onColorClick} color={color} disabled={!!drawType} />
        </WidgetToolbar>
    );
};
